import { gql } from '@apollo/client';

const ASYNC_PROCESS_COMPLETION_FRAGMENT = gql`
  fragment AsyncProcessCompletionFragment on AsyncProcessCompletion {
    __typename
    ... on AsyncProcessCompletionPending {
      checkAfterMilliseconds
    }
  }
`;

export const CHECK_PAYMENT_COMPLETION_QUERY = gql`
  ${ASYNC_PROCESS_COMPLETION_FRAGMENT}
  query checkPaymentCompletionQuery(
    $token: String!
    $type: PaymentDocumentType!
  ) {
    checkPaymentCompletion(token: $token, type: $type) {
      ...AsyncProcessCompletionFragment
    }
  }
`;

export const CHECK_PAYMENT_SETUP_COMPLETION_QUERY = gql`
  ${ASYNC_PROCESS_COMPLETION_FRAGMENT}
  query checkPaymentSetupCompletionQuery($setupToken: String!) {
    checkPaymentSetupCompletion(setupToken: $setupToken) {
      ...AsyncProcessCompletionFragment
    }
  }
`;
